import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { HomeViewsUserPreferencesQuery } from './HomeViewsUserPreferencesQuery.graphql';

export const preloadOptions = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	if (!isLoggedIn) {
		return Promise.resolve({});
	}
	/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
	return query({ query: HomeViewsUserPreferencesQuery });
};
